import React, { useEffect, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams, useLocation } from "react-router-dom"
import { getTokenProfile } from "store/auth/action"

import PageContainer from "components/common/PageContainer"

const AuthPage = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { token } = useParams()
  const isLoading = useSelector((state) => state.authReducer.isLoading)

  useEffect(() => {
    localStorage.setItem("token", token)
    dispatch(getTokenProfile())
  }, [dispatch, location.search, token])

  return (
    <Fragment>
      <PageContainer isPageLoading={isLoading}>Loading</PageContainer>
    </Fragment>
  )
}

export default AuthPage
